import React from 'react';
import { colors, type, space, radius, motion } from '../tokens';
import { movesConfig } from '../icons';

// Visual pipeline chip-strip for cultivation moves.
// Current stage highlighted; click to advance.
const MovesFunnel = ({
  current = 'id',
  onChange,
  orientation = 'horizontal',
  compact = false,
}) => {
  const currentIdx = movesConfig.findIndex(s => s.id === current);
  const isVert = orientation === 'vertical';

  return (
    <div style={{
      display: 'flex',
      flexDirection: isVert ? 'column' : 'row',
      gap: 2,
      alignItems: 'stretch',
      width: '100%',
    }}>
      {movesConfig.map((stage, i) => {
        const reached = i <= currentIdx;
        const isCurrent = i === currentIdx;
        const color = reached ? stage.color : colors.surfaceInk;
        const labelColor = reached
          ? (isCurrent ? '#fff' : colors.textInverse)
          : colors.textTertiary;

        return (
          <button
            key={stage.id}
            onClick={() => onChange && onChange(stage.id)}
            title={stage.label}
            style={{
              flex: 1,
              minWidth: 0,
              padding: compact ? `${space[1]}px ${space[2]}px` : `${space[2]}px ${space[2]}px`,
              background: color,
              color: labelColor,
              border: isCurrent ? `2px solid ${colors.textPrimary}` : `1px solid ${reached ? color : colors.border}`,
              borderRadius: radius.sm,
              ...type.micro,
              fontWeight: isCurrent ? 700 : 500,
              fontFamily: 'inherit',
              cursor: onChange ? 'pointer' : 'default',
              transition: `all ${motion.fast}`,
              textAlign: 'center',
              whiteSpace: 'nowrap',
              overflow: 'hidden',
              textOverflow: 'ellipsis',
              position: 'relative',
              boxShadow: isCurrent ? `0 2px 6px ${stage.color}55` : 'none',
            }}
          >
            {compact ? stage.label.slice(0, 4) : stage.label}
          </button>
        );
      })}
    </div>
  );
};

export default MovesFunnel;
